import React from "react";

const DataFlows = () => {
  return (
    <div className="flow__box">
      <div className="container">
        <div className="flow__heading text__heading ta-c reveal-from-top">
          Automate your entire data workflows
        </div>
        <div className="flow__sub text__sub ta-c reveal-from-top">
          Everything you need in one single modern data platform
        </div>
        <div className="flow__content-box reveal-from-bottom" data-reveal-delay="200">
          <div className="flow__content">
            <div className="content__heading">1</div>
            <div className="content__sub">Hour setup</div>
          </div>
          <div className="flow__content">
            <div className="content__heading">50%</div>
            <div className="content__sub">
              Cost savings compared to building your own data stack
            </div>
          </div>
          <div className="flow__content">
            <div className="content__heading">10X</div>
            <div className="content__sub">More users accesing data</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataFlows;
